<template>
  <div class="input-group" :class="['generic-date-picker', containerClass, sizeClass]">
    <input type="date" class="form-control" ref="text" :placeholder="placeholder" :title="currentToolTip" :readOnly="readOnly" :value="text" @input="updateText" @keyup.esc="showPicker($event)" @keyup="eventGeneric('keyup', $event)">
    <div class="input-group-append mx-0 d-print-none">
      <button class="btn btn-info" title="Max" type="button" @click="max"><i class="fas fa-arrow-right"></i></button>
    </div>
    <div class="input-group-append mx-0">
      <b-form-datepicker ref="picker" :value="currentDate" @input="updateDate" @hidden="pickerHidden" :class="[buttonClass, sizeClass]" @context="onContext" button-only
        hide-header :nav-button-variant="navVariant" right locale="en-US" reset-button
        today-button close-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :date-disabled-fn="dateDisabled"></b-form-datepicker>
    </div>
  </div>
</template>
<script>
  export default {
    name: "generic-date-picker",
    props: {
      value: String,
      placeholder: {
        type: String,
        required: false,
        default: ''
      },
      containerClass: {
        type: String,
        default: ''
      },
      sizeClass: {
        type: String,
        default: ''
      },
      buttonClass: {
        type: String,
        default: 'px-0'
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      toolTip: {
        type: String,
        default: ''
      },
      dateDisabledFn: {
        type: Function
      }
    },
    data() {
      return {
        text: this.value,
        currentDate: this.value,
        formatted: '',
        selected: '',
        manuallyShown: false
      };
    },
    watch: {
      value: function(val) {
        this.currentDate = val;
        this.text = val;
      },
    },
    computed: {
      currentToolTip() {
        return this.text || this.toolTip;
      },
      navVariant() {
        if (!window.appState.theme || window.appState.theme === '') {
          return 'secondary';
        } else {
          switch (window.appState.theme.toLowerCase()) {
            case 'flatly':
            case 'litera':
            case 'sandstone':
              return 'primary';
            case 'slate':
              return 'secondary';
            case 'darkly':
              return 'light';
            case 'superhero':
              return 'primary';
            default:
              return 'dark';
          }
        }
      },
    },
    methods: {
      dateDisabled(ymd, date) {
        if (this.dateDisabledFn) {
          if (!date && ymd && ymd.length) {
            date = dayjs(ymd).toDate();
          }
          return this.dateDisabledFn(ymd, date);
        }
        return false;
      },
      updateText(event) {
        if (!this.readOnly) {
          let newVal = this.$refs.text.value;
          this.currentDate = newVal;
          this.text = newVal;
          this.$emit('input', newVal);
          this.$emit('change', newVal);
        }
      },
      updateDate(val) {
        if (!this.readOnly) {
          let newVal = val;
          this.currentDate = newVal;
          this.text = newVal;
          this.$emit('input', newVal);
          this.$emit('change', newVal);
        }
      },
      max() {
        this.updateDate('9999-12-31');
      },
      focus() {
        this.$refs.text.focus();
      },
      eventGeneric(name, event) {
        this.$emit(name, event);
      },
      onContext(ctx) {
        this.formatted = ctx.selectedFormatted
        this.selected = ctx.selectedYMD
      },
      pickerHidden(event) {
        if (this.manuallyShown) {
          //TODO Figure out a way to make this actually work as it would be nice
          Vue.nextTick(this.focus);
        }
        this.manuallyShown = false;
      },
      showPicker(event) {
        this.manuallyShown = true;
        this.$refs.picker.$refs.control.show();
      }
    }
  };
</script>